var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCorner1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 567,
    height: 84,
    viewBox: "0 0 567 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M607.849 94.7206C606.118 95.7674 604.088 96.6011 601.859 97.1815C591.53 100.127 571.18 97.0899 559.31 96.8407L477.75 95.0236L260.953 90.2177L-48.6417 83.3354L-49.3116 83.3054C-49.4079 61.214 -60.4601 27.3325 -35.982 9.59468C-23.4345 0.470529 -1.45021 -1.23627 17.833 1.20231C37.1161 3.6409 54.9789 9.47504 73.738 13.3635C115.785 22.0733 161.15 20.7336 203.447 28.955C225.602 33.2644 246.443 40.1159 268.073 45.5037C300.69 53.625 334.929 58.3726 368.986 63.0993C411.73 69.0089 454.799 74.9459 498.214 75.4535C525.627 75.7576 553.235 73.918 580.291 77.5115C592.961 79.1674 618.249 88.1267 607.849 94.7206Z",
    fill: "#633025"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorner1);
export default __webpack_public_path__ + "static/media/corner_1.9a6be0a219022eb50bc65c86da657309.svg";
export { ForwardRef as ReactComponent };